<template>
  <div>
    <el-table
      :data="disabledList.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column width="100%">
        <template slot-scope="props">
          <img
            v-if="props.row.image_url"
            class="avatar"
            :src="props.row.image_url"
          />
          <img
            v-else
            class="avatar"
            :src="`https://syncvault.com/static/apple-touch-icon.png`"
          />
        </template>
      </el-table-column>
      <el-table-column label="Channel">
        <template slot-scope="props">
          {{ props.row.title }}<br>
          ID: {{props.row.channelId}}
        </template>
      </el-table-column>
      <el-table-column
          label="Requested By"
          prop="requester.email"
          sortable
      ></el-table-column>
      <el-table-column label="Requested" prop="requested_at" sortable>
        <template slot-scope="props">
          {{ props.row.requested_at | datetime }}
        </template>
      </el-table-column>
      <el-table-column label="Deleted" prop="deleted_at" sortable>
        <template slot-scope="props">
          {{ props.row.deleted_at | datetime }}
        </template>
      </el-table-column>
      <el-table-column label="Requested Action">
        <template slot-scope="props">
          <el-tag v-if="props.row.reason_for_rejection && props.row.reason_for_add_request" type="danger">
            Rejected Insert
          </el-tag>
          <el-tag v-else-if="props.row.reason_for_rejection && props.row.reason_for_delete_request" type="danger">
            Rejected Delete
          </el-tag>
          <el-tag v-else-if="props.row.reason_for_delete_request && props.row.action === 'Delete'" type="danger">
            Deleted By Request
          </el-tag>
          <el-tag v-else type="danger">
            Deleted By Admin
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Review" placement="top">
            <el-button
              type="info"
              circle
              size="small"
              icon="el-icon-edit"
              @click="review(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @current-change="currentChange"
      :current-page.sync="disabledList.current_page"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="disabledList.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeWhitelist', [
      'disabledList',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeWhitelist', ['setPage', "setDialogDisabled", "setSelectedDisabled"]),
    ...mapActions('youtubeWhitelist', ['readDisabledList']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readDisabledList()
    },
    review(row) {
      this.setDialogDisabled(true)
      this.setSelectedDisabled(row)
    }
  },

  created() {
    this.readDisabledList()
  }
}
</script>
]
